<template>
  <div class="referral-navigation border-top mx-2">
    <div class="row py-3">
      <div class="col">
        <div class="referral-navigation__move">
          <h1
            class="fa fa-caret-square-left color-gray-7 mt-1 mt-md-0 mt-sm-1"
            @click="move(moveDirections.back)"
          />
          <span
            class="color-gray-7 font-16 font-weight-bold ml-3 mt-n2 d-block d-md-block d-sm-none"
          >
            Referido Anterior
          </span>
        </div>
      </div>
      <div class="col text-center pt-1 pt-md-2 pt-sm-1">
        <div
          class="d-flex align-items-center justify-content-center referral-navigation__paging"
        >
          <div class="referral-navigation__paging__input">
            <input
              ref="inputRef"
              v-model="pageNumber"
              :disabled="disabledPaging"
              maxlength="2"
              type="text"
              @blur="onPressEnter"
              @keydown.enter="onPressEnter"
              @keypress="isNumber($event)"
            />
          </div>
          <div
            class="bg-gray-5 px-4 cursor-pointer d-flex justify-content align-items-center color-green font-14 font-weight-bold rounded-right referral-navigation__paging__total"
            @click="onEmitChange(size)"
          >
            {{ size }}
          </div>
        </div>
      </div>
      <div class="col text-right">
        <div class="referral-navigation__move justify-content-end">
          <span
            class="color-gray-7 font-16 font-weight-bold mt-n2 mr-3 d-block d-md-block d-sm-none"
          >
            Referido Siguiente
          </span>
          <h1
            class="fa fa-caret-square-right color-gray-7 mt-1 mt-md-0 mt-sm-1"
            @click="move(moveDirections.forward)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferralNavigation',
  props: {
    page: {
      type: Number,
      default: () => 0,
    },
    size: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      pageNumber: this.page,
    };
  },
  computed: {
    moveDirections() {
      return {
        back: 1,
        forward: 2,
      };
    },
    disabledPaging() {
      return this.size === 0;
    },
  },
  watch: {
    page: {
      immediate: true,
      handler(value) {
        this.pageNumber = value + 1;
      },
    },
  },
  methods: {
    move(direction) {
      if (direction === this.moveDirections.back && this.pageNumber > 1) {
        this.pageNumber = this.pageNumber - 1;
        this.onEmitChange(this.pageNumber);
      }
      if (
        direction === this.moveDirections.forward &&
        this.pageNumber < this.size
      ) {
        this.pageNumber = this.pageNumber + 1;
        this.onEmitChange(this.pageNumber);
      }
    },
    onPressEnter() {
      this.onEmitChange(this.pageNumber);
    },
    onEmitChange(page) {
      if (!this.disabledPaging) {
        this.$emit('on-change-page', page);
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.referral-navigation {
  &__move {
    display: flex;
    align-items: center;
    h1 {
      cursor: pointer;
    }
  }
  &__paging {
    &__input {
      input {
        height: 36px;
        width: 62px;
        border: unset;
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        padding: 1px;
        border: 1px solid map-get($colors, 'gray-5');
        text-align: center;
        &:focus {
          outline: none !important;
        }
      }
    }
    &__total {
      height: 36px;
    }
  }
}
</style>
